
import React from 'react';

interface LessonHeaderProps {
  day: number;
  title: string;
  subtitle: string;
}

const LessonHeader: React.FC<LessonHeaderProps> = ({ 
  day, 
  title, 
  subtitle 
}) => {
  return (
    <div className="space-y-2">
      <div className="text-sm font-medium text-hormony-charcoal/70">
        Day {day}
      </div>
      <h1 className="text-2xl font-display font-semibold text-hormony-charcoal">
        {title}
      </h1>
      <p className="text-hormony-charcoal/70 text-lg">
        {subtitle}
      </p>
      {subtitle && (
        <div className="bg-hormony-light-coral/10 px-4 py-3 rounded-lg text-sm text-hormony-charcoal/80 mt-2">
          <span className="font-medium">Topic:</span> {subtitle}
        </div>
      )}
    </div>
  );
};

export default LessonHeader;
